import { useEffect, useState } from 'react';
import API from '../api';
import { useToast } from '../context/ToastContext';
import { useNotifications } from '../context/NotificationContext';

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  const { addToast } = useToast();
  const { refresh: refreshBadge } = useNotifications();

  const load = () => API.get('notifications/').then((r) => setNotifs(r.data.results || r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await API.post(`notifications/${id}/marquer_lue/`);
    load();
    refreshBadge();
  };

  const markAllRead = async () => {
    await API.post('notifications/tout_lire/');
    addToast('Toutes les notifications marquées comme lues', 'success');
    load();
    refreshBadge();
  };

  const typeIcons = { examen: 'bi-pencil-square', publication: 'bi-book', resultat: 'bi-bar-chart', general: 'bi-bell' };

  return (
    <div>
      <div className="notif-header">
        <div className="page-header">
          <h2><i className="bi bi-bell" /> Notifications</h2>
          <p>{notifs.filter(n => !n.lue).length} non lue{notifs.filter(n => !n.lue).length > 1 ? 's' : ''}</p>
        </div>
        <button onClick={markAllRead} className="btn btn-secondary btn-sm">
          <i className="bi bi-check-all" /> Tout marquer comme lu
        </button>
      </div>
      {notifs.length === 0 ? (
        <div className="empty-state"><i className="bi bi-bell-slash" /><p>Aucune notification</p></div>
      ) : (
        <ul className="notif-list">
          {notifs.map((n) => (
            <li key={n.id} className={`notif-item ${n.lue ? 'lue' : 'non-lue'}`}>
              <div className="notif-icon"><i className={`bi ${typeIcons[n.type_notif] || 'bi-bell'}`} /></div>
              <div className="notif-content">
                <strong>{n.titre}</strong>
                <p>{n.message}</p>
                <small>{new Date(n.created_at).toLocaleString('fr-FR')}</small>
              </div>
              {!n.lue && (
                <button className="btn btn-sm btn-ghost" onClick={() => markRead(n.id)}>
                  <i className="bi bi-check2" /> Lu
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
